import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AdminAuth from '../components/admin/AdminAuth';
import WidgetDashboard from '../components/admin/WidgetDashboard';
import SubmissionReview from '../components/admin/SubmissionReview';

const TABS = [
  { key: 'widgets', label: 'Widgets' },
  { key: 'submissions', label: 'Submissions' }
];

const WidgetsAdminPage = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'widgets';

  return (
    <AdminAuth>
      <div className="max-w-6xl mx-auto space-y-6">
        {/* Header */}
        <div>
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate('/admin')}
              className="text-gray-400 hover:text-gray-200 transition-colors text-sm"
            >
              &larr;
            </button>
            <h1 className="text-3xl font-bold text-gray-100">Widgets & Submissions</h1>
          </div>
          <p className="text-gray-400 mt-1">Directory widgets and submission review</p>
        </div>

        {/* Tab Bar */}
        <div className="flex items-center justify-between">
          <div className="flex gap-1 bg-gray-800 rounded-lg p-1">
            {TABS.map(tab => (
              <button
                key={tab.key}
                onClick={() => setSearchParams(tab.key === 'widgets' ? {} : { tab: tab.key })}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                  activeTab === tab.key
                    ? 'bg-gray-700 text-gray-100'
                    : 'text-gray-400 hover:text-gray-200'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
          <button
            onClick={() => navigate('/admin/widget/new')}
            className="bg-green-600 hover:bg-green-700 text-white px-3 py-2 rounded-lg transition-colors inline-flex items-center gap-1 text-sm"
          >
            + New Widget
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === 'widgets' && <WidgetDashboard embedded />}
        {activeTab === 'submissions' && <SubmissionReview embedded />}
      </div>
    </AdminAuth>
  );
};

export default WidgetsAdminPage;
